import Filter from "./filter.component";

export default Filter;
